import React from 'react';
import { Backdrop, Slide, Box, useMediaQuery, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import theme from '../styles/theme';
import ListingOnboardingFlow from '../pages/listing_onboarding/ListingOnboardingFlow';

interface ListingOnboardingOverlayProps {
  open: boolean;
  onClose: () => void;
}

const ListingOnboardingOverlay: React.FC<ListingOnboardingOverlayProps> = ({ open, onClose }) => {
  const isDesktop = useMediaQuery('(min-width:960px)');
  return (
      <Backdrop
        open={open}
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
        onClick={e => {
          if (e.target === e.currentTarget) onClose();
        }}
      >
        <Slide direction="up" in={open} mountOnEnter unmountOnExit>
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Paper
              sx={{
                p: 0,
                borderRadius: 6,
                width: isDesktop ? '50%' : '100%',
                maxWidth: isDesktop ? '50%' : '100%',
                maxHeight: '90vh',
                minHeight: '90vh',
                overflowY: 'auto',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                margin: isDesktop ? 'auto' : 0,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <IconButton
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  zIndex: 4,
                }}
              >
                <CloseIcon sx={{ color: 'black' }}/>
              </IconButton>
              <ListingOnboardingFlow isOverlay={true}/>
            </Paper>
          </Box>
        </Slide>
      </Backdrop>
  );
};

export default ListingOnboardingOverlay;